import { useSeoMeta } from '@unhead/react';
import { Header } from '@/components/Header';
import { HeroBanner } from '@/components/HeroBanner';
import { AnnouncementVideo } from '@/components/AnnouncementVideo';
import { HowItWorks } from '@/components/HowItWorks';
import { NostrCTA } from '@/components/NostrCTA';
import { Footer } from '@/components/Footer';

const Index = () => {
  useSeoMeta({
    title: 'Bitcoin Maxi Madness - Vote for the Ultimate Maximalist',
    description: 'Who is the biggest Bitcoin maximalist? Vote in every round of this March Madness-style bracket challenge. Powered by Nostr polls - your votes are sovereign and censorship-proof.',
  });

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <HeroBanner />
        <AnnouncementVideo />
        <HowItWorks />
        <NostrCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
